// Angular
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { OtherApiService } from 'src/app/Services/other.service';
import { ReportNotificationService } from 'src/app/Services/reportNotification.service';
// import { MatTooltip } from '@angular/material';

@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
	host: {
		'(document:click)': 'closePopup($event)',
	  },
})
export class TopbarComponent {
	entityName = localStorage.getItem('entityName')
	userMobile = localStorage.getItem('mobile')
	userName = localStorage.getItem('name')
	contactEmail = localStorage.getItem('contactEmail')
	userType :any;
	showPopupData : boolean 
	clickEvent : any 
	primaryColour:any;
	tritaryColour:any;
	permissions = localStorage.getItem('permissions');
	showReportTooltip: boolean = false;
	entityPreferences: any;
	displayNames: any = {};

	constructor(  private service: OtherApiService,private router:Router, private reportNotificationService: ReportNotificationService) { }

	ngOnInit() {
		this.userType = localStorage.getItem('userType');
		this.primaryColour = this.service.passColour()	
		this.tritaryColour = "#fffffff"		
		this.loadDisplayNames();
		
		this.reportNotificationService.reportGenerated$.subscribe(() => {
			this.showReportTooltip = true;
			setTimeout(() => {
				this.showReportTooltip = false;
			}, 4000);
		});
	}
	loadDisplayNames() {
		try {
			this.entityPreferences = JSON.parse(localStorage.getItem('entityPreferences'));
			if (this.entityPreferences && this.entityPreferences.displayNames) {
				const advancedItem = this.entityPreferences.displayNames.find(item => item.value == 'advanced');
				this.displayNames = {
					advanced: advancedItem && advancedItem.name ? advancedItem.name : 'Advanced'
				};
			} else {
				this.displayNames = { advanced: 'Advanced' };
			}
		} catch (e) {
			this.displayNames = { advanced: 'Advanced' };
		}
	}
	showPopup(event){
		this.loadDisplayNames();
		this.showPopupData = true
		this.clickEvent = event
		

	}
	closePopup(event) {
		if (this.clickEvent.target != event.target ) // or some similar check
{		
	this.showPopupData = false
}
			
	   }
	redirect(route){
		this.router.navigate([route])
	}
	checkPermission(value){
	
		if(this.permissions.includes(value)){
		  return true;
		}else{
		  return false;
		}
	  }
	createTicket(){
		 window.open( 'https://data.odpay.in/odforms1/form/BugTracker/formperma/nXRLFMBDgeyMadv0uD7-AFRLrx6zhw9q59yh1ToH_N4?entityName='+this.entityName+'&userName='+this.userName+'&userMobile='+this.userMobile+'&contactEmail='+this.contactEmail,  "_blank");
	}
 }
